module.exports = __webpack_public_path__ + "static/media/avatar5.66dbedb7.png";